import { render, staticRenderFns } from "./UpdateTrainingProgram.vue?vue&type=template&id=a1df2220&scoped=true"
import script from "./UpdateTrainingProgram.vue?vue&type=script&lang=js"
export * from "./UpdateTrainingProgram.vue?vue&type=script&lang=js"
import style0 from "./UpdateTrainingProgram.vue?vue&type=style&index=0&id=a1df2220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1df2220",
  null
  
)

export default component.exports